<template>
  <div id="users-table">
    <!------------------------- Table  starts------------------------->
    <v-data-table
      :items="users"
      :headers="headers"
      :loading="isLoading"
      class="body-2 elevation-2"
      :options.sync="pagination"
      :footer-props="footerProps"
      @current-items="setCurrentItems"
      :header-props="{ class: 'subtitle-2' }"
      :items-per-page="paginationMeta.itemsPerPage"
      :loading-text="$dictionary.app.common.users.loading"
      :server-items-length="paginationMeta.serverItemsLength"
      :no-data-text="$dictionary.app.manageUsers.index.noResults"
    >
      <template #item.email="{ item }">
        <table-matrics-row
          @click="navigate(item)"
          is-text-pointer
          :text="item.email"
          textClass="blue--text"
        />
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-menu left bottom offset-y>
          <template #activator="{ on, attrs }">
            <v-btn icon v-on="on">
              <v-icon v-bind="attrs" class="text--secondary">
                mdi-dots-vertical
              </v-icon>
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item @click="deleteUser(item)">
              <v-icon class="mr-3 text--secondary">
                mdi-delete
              </v-icon>
              <v-list-item-title class="primary--font body-2 pr-3">
                Delete User
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <!------------------------- Table ends ------------------------->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { TableMatricsRow } from "../shared";
import { PaginationSortMixin } from "@/mixins";

/**
 * Users table
 * @todo verify status property value in user object. Api is not available right now
 * Currently status value of a user is not being returned by admin users api.
 */
export default {
  name: "UsersTable",
  /**
   * ---------------- Components ------------------
   */
  components: {
    TableMatricsRow,
  },
  /**
   * ---------------- Mixins ------------------
   */
  mixins: [PaginationSortMixin],
  /**
   * ---------------- Props ------------------
   */
  props: {
    /**
     * List of users to be displayed in table
     */
    users: { type: Array, required: true },
    isLoading: { type: Boolean, required: true },
    headers: { type: Array, required: true },
    fetchUsers: { type: Boolean, required: true, default: false },
  },
  /**
   * ---------------- Custom events ------------------
   */
  emits: ["delete-user", "current-items"],
  /**
   * ---------------- Data properties ------------------
   */
  data() {
    return {
      defaultSortOrder: "email",
      sortDesc: false,
    };
  },
  /**
   * ---------------- Computed properties ------------------
   */
  computed: {
    /**
     * Accounts table pagination data
     * @type {Object}
     */
    paginationMeta() {
      return {
        itemsPerPage: this.pagination.itemsPerPage || 10,
        serverItemsLength:
          this.pagination.page * this.users?.length +
          this.pagination.itemsPerPage,
      };
    },
  },
  /**
   * ---------------- Methods ------------------
   */
  methods: {
    /**
     * Maps store action in the component
     */
    ...mapActions({
      setSnackbar: "ui/setSnackbar",
    }),
    /**
     * Navigates to user details page
     * @todo Change account_id param to user_id. Currently we are no recieving user id of a user in user index api
     */
    navigate({ id }) {
      const query = { active_tab: "profile" };
      this.$router.push({ name: "user", params: { id }, query });
    },
    /**
     * Delete user
     * @param {Object} item User details
     * @todo Consumes delete service method to delete the user
     */
    deleteUser(item) {
      this.$emit("delete-user", { ...item });
    },
    /**
     * Sets current items being rendered in the table
     * @emits current-items
     */
    setCurrentItems(items) {
      this.$emit("current-items", [...items]);
    },
  },
  /**
   * ---------------- Watching properties ------------------
   */
  watch: {
    /**
     * Watches fetchUsers prop when its value is true
     * @emits get-records custom event is emitted to fetch updated user list
     */
    fetchUsers() {
      this.getRecords();
    },
  },
  /**
  |--------------------------------------------------
  | Created lifecycle hook
  |--------------------------------------------------
  */
  created() {
    this.getRecords();
  },
};
</script>
